import React from 'react';
import styles from '../assets/css/Dashboard.module.css';
import { motion } from 'framer-motion';
import { FaUserCircle, FaDatabase, FaChartBar } from 'react-icons/fa';

import ParticleBackground from '../components/ParticleBackground';
import { toast } from 'react-toastify';

function Dashboard() {
  // Notificación al cargar el dashboard
  React.useEffect(() => {
    toast.success('¡Bienvenido al panel!', {
      position: 'top-right',
      autoClose: 3000,
    });
  }, []);

  return (
    <div className={styles.container}>
      <ParticleBackground />

      <motion.header
        className={styles.header}
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h1>Bienvenido a tu panel</h1>
        <p>Accedé a tus datos y funcionalidades desde aquí</p>
      </motion.header>

      <div className={styles.grid}>
        <motion.div
          className={styles.card}
          whileHover={{ scale: 1.03 }}
          transition={{ type: 'spring', stiffness: 300 }}
        >
          <FaUserCircle className={styles.icon} />
          <h3>Perfil</h3>
          <p>Visualizá y editá tu información personal</p>
        </motion.div>

        <motion.div
          className={styles.card}
          whileHover={{ scale: 1.03 }}
          transition={{ type: 'spring', stiffness: 300 }}
        >
          <FaDatabase className={styles.icon} />
          <h3>Validaciones</h3>
          <p>Consultá tus validaciones recientes</p>
        </motion.div>

        <motion.div
            className={styles.card}
            whileHover={{ scale: 1.03 }}
            transition={{ type: 'spring', stiffness: 300 }}
          >
            <FaChartBar className={styles.icon} />
            <h3>Estadisticas</h3>
            <p>Revisá los datos de uso y actividad</p>
        </motion.div>

      </div>
    </div>
  );
}

export default Dashboard;
